// extracted by mini-css-extract-plugin
export default {"root":"FooterLinkedLogo_root__WGO6d"};